<template>
  <div class="property-owner-detail-page">
    <div class="property-white-card">
      <div class="detail-header">
        <div class="detail-title">业主信息详情</div>
        <el-button size="small" class="detail-back-btn" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="owner-profile">
        <div class="owner-avatar-card">
          <el-image class="owner-avatar-large" :src="ownerInfo.faceUrl || ownerInfo.ownerPhoto || '/img/noPhoto.jpg'" fit="cover" />
        </div>
        <div class="owner-fields">
          <div class="owner-field"><span>业主ID：</span>{{ ownerInfo.ownerId || '-' }}</div>
          <div class="owner-field"><span>姓名：</span>{{ ownerInfo.name || '-' }}</div>
          <div class="owner-field"><span>性别：</span>{{ genderText(ownerInfo.sex) }}</div>
          <div class="owner-field"><span>人员类型：</span>{{ ownerInfo.personTypeName || '-' }}</div>
          <div class="owner-field"><span>人员角色：</span>{{ ownerInfo.personRoleName || '-' }}</div>
          <div class="owner-field"><span>证件号：</span>{{ ownerInfo.idCard || '-' }}</div>
          <div class="owner-field"><span>联系电话：</span>{{ ownerInfo.link || '-' }}</div>
          <div class="owner-field"><span>创建员工：</span>{{ ownerInfo.userName || '-' }}</div>
          <div class="owner-field owner-field-remark"><span>备注：</span>{{ ownerInfo.remark || '-' }}</div>
        </div>
      </div>

      <div class="detail-tabs">
        <button v-for="tab in tabs" :key="tab.name" :class="['detail-tab', { active: activeTab === tab.name }]" @click="changeTab(tab.name)">{{ tab.label }}</button>
      </div>

      <div class="detail-toolbar">
        <div class="toolbar-left">
          <el-button v-if="activeTab === 'rooms'" size="small" class="property-btn-add" @click="openAddRoomDialog">添加</el-button>
          <el-button v-if="activeTab === 'cars'" size="small" class="property-btn-add" @click="openAddCarDialog">添加</el-button>
          <el-button v-if="activeTab === 'members'" size="small" class="property-btn-add" @click="openAddMemberDialog">添加</el-button>
          <el-button size="small" class="property-btn-refresh" title="刷新" @click="refreshCurrentTab"><i class="el-icon-refresh-right"></i></el-button>
        </div>
        <div class="toolbar-search">
          <el-input v-model="keyword" size="small" class="property-search-input" placeholder="请输入" clearable @keyup.enter.native="queryCurrentTab" />
          <el-button size="small" class="property-btn-search" @click="queryCurrentTab"><i class="el-icon-search"></i>搜索</el-button>
        </div>
      </div>

      <div class="detail-table-section">
        <el-table v-if="activeTab === 'rooms'" v-loading="loading" :data="roomRows" :header-cell-style="headerCellStyle" :cell-style="cellStyle" style="width: 100%">
          <el-table-column prop="communityName" label="小区" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.communityName || '-' }}</template>
          </el-table-column>
          <el-table-column label="房屋编号" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ roomName(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="layer" label="楼层" min-width="110" show-overflow-tooltip />
          <el-table-column prop="roomSubTypeName" label="类型" min-width="120" show-overflow-tooltip />
          <!-- <el-table-column label="建筑/室内面积" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.builtUpArea || '-' }}/{{ scope.row.roomArea || '-' }}</template>
          </el-table-column> -->
          <el-table-column label="建筑面积" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.builtUpArea || '-' }}</template>
          </el-table-column>
          <el-table-column label="有效期" min-width="220" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.startTime || '-' }}～{{ scope.row.endTime || '-' }}</template>
          </el-table-column>
          <el-table-column prop="stateName" label="房屋状态" min-width="120">
            <template slot-scope="scope"><span :class="['status-tag', statusClass(scope.row.state)]">{{ scope.row.stateName || '-' }}</span></template>
          </el-table-column>
        </el-table>

        <el-table v-if="activeTab === 'cars'" v-loading="loading" :data="carRows" :header-cell-style="headerCellStyle" :cell-style="cellStyle" style="width: 100%">
          <el-table-column prop="carNum" label="车牌号" min-width="140" show-overflow-tooltip />
          <el-table-column prop="leaseTypeName" label="类型" min-width="120" show-overflow-tooltip />
          <el-table-column prop="carTypeName" label="车辆类型" min-width="120" show-overflow-tooltip />
          <el-table-column prop="carColor" label="颜色" min-width="100" show-overflow-tooltip />
          <el-table-column label="车主" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.ownerName || '-' }}{{ scope.row.link ? `(${scope.row.link})` : '' }}</template>
          </el-table-column>
          <el-table-column label="车位" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.areaNum && scope.row.num ? `${scope.row.areaNum}-${scope.row.num}` : '-' }}</template>
          </el-table-column>
          <el-table-column label="有效期" min-width="220" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.startTime || '-' }}～{{ scope.row.endTime || '-' }}</template>
          </el-table-column>
        </el-table>

        <el-table v-if="activeTab === 'members'" v-loading="loading" :data="memberRows" :header-cell-style="headerCellStyle" :cell-style="cellStyle" style="width: 100%">
          <el-table-column prop="name" label="名称" min-width="130" show-overflow-tooltip />
          <el-table-column label="性别" min-width="90"><template slot-scope="scope">{{ genderText(scope.row.sex) }}</template></el-table-column>
          <el-table-column prop="personRoleName" label="人员角色" min-width="130" show-overflow-tooltip />
          <el-table-column prop="idCard" label="身份证" min-width="190" show-overflow-tooltip />
          <el-table-column prop="link" label="联系方式" min-width="140" show-overflow-tooltip />
          <el-table-column prop="address" label="地址" min-width="180" show-overflow-tooltip />
          <el-table-column label="操作" min-width="100">
            <template slot-scope="scope"><a class="action-link danger" @click="deleteMember(scope.row)">删除</a></template>
          </el-table-column>
        </el-table>

        <el-table v-if="activeTab === 'complaints'" v-loading="loading" :data="complaintRows" :header-cell-style="headerCellStyle" :cell-style="cellStyle" style="width: 100%">
          <el-table-column prop="typeName" label="类型" min-width="130" show-overflow-tooltip />
          <el-table-column prop="roomName" label="房屋" min-width="160" show-overflow-tooltip />
          <el-table-column prop="complaintName" label="联系人" min-width="120" show-overflow-tooltip />
          <el-table-column prop="tel" label="联系电话" min-width="140" show-overflow-tooltip />
          <el-table-column prop="currentUserName" label="处理人" min-width="120" show-overflow-tooltip />
          <el-table-column prop="currentUserTel" label="处理人电话" min-width="140" show-overflow-tooltip />
          <el-table-column prop="createTime" label="创建时间" min-width="190" show-overflow-tooltip />
          <el-table-column prop="stateName" label="状态" min-width="110"><template slot-scope="scope"><span class="status-tag status-unsold">{{ scope.row.stateName || '-' }}</span></template></el-table-column>
        </el-table>

        <el-table v-if="activeTab === 'repairs'" v-loading="loading" :data="repairRows" :header-cell-style="headerCellStyle" :cell-style="cellStyle" style="width: 100%">
          <el-table-column prop="repairId" label="工单编码" min-width="180" show-overflow-tooltip />
          <el-table-column prop="repairObjName" label="位置" min-width="160" show-overflow-tooltip />
          <el-table-column prop="repairTypeName" label="报修类型" min-width="130" show-overflow-tooltip />
          <el-table-column prop="repairName" label="报修人" min-width="120" show-overflow-tooltip />
          <el-table-column prop="tel" label="联系方式" min-width="140" show-overflow-tooltip />
          <el-table-column prop="appointmentTime" label="预约时间" min-width="190" show-overflow-tooltip />
          <el-table-column prop="stateName" label="状态" min-width="120"><template slot-scope="scope"><span class="status-tag status-unsold">{{ scope.row.stateName || '-' }}</span></template></el-table-column>
        </el-table>

      </div>

      <div class="property-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination :current-page="pagination.current" :page-size="pagination.size" layout="prev, pager, next" :total="pagination.total" @current-change="handleCurrentChange" />
        <el-select v-model="pagination.size" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <el-dialog title="添加成员" :visible.sync="memberDialogVisible" width="650px" custom-class="property-owner-dialog" :close-on-click-modal="false">
      <el-form :model="memberForm" :rules="memberRules" ref="memberFormRef" label-width="96px" class="dialog-form">
        <el-form-item label="人员角色" prop="personRole"><el-select v-model="memberForm.personRole" placeholder="请选择"><el-option label="租客" value="2" /><el-option label="家庭成员" value="3" /><el-option label="公司员工" value="4" /><el-option label="其他" value="99" /></el-select></el-form-item>
        <el-form-item label="性别" prop="sex"><el-select v-model="memberForm.sex" placeholder="请选择"><el-option label="男" value="0" /><el-option label="女" value="1" /></el-select></el-form-item>
        <el-form-item label="客户名称" prop="name"><el-input v-model="memberForm.name" placeholder="请输入" /></el-form-item>
        <el-form-item label="联系手机" prop="link"><el-input v-model="memberForm.link" placeholder="请输入" /></el-form-item>
        <el-form-item label="备用手机"><el-input v-model="memberForm.concactLink" placeholder="请输入" /></el-form-item>
        <el-form-item label="地址:"><el-input v-model="memberForm.address" placeholder="请输入" /></el-form-item>
        <el-form-item label="门禁钥匙:"><el-select v-model="memberForm.accessKey" placeholder="请选择"><el-option label="上是" value="Y" /><el-option label="否" value="N" /></el-select></el-form-item>
        <el-form-item label="身份证:"><el-input v-model="memberForm.idCard" placeholder="请输入" /></el-form-item>
        <el-form-item label="备注:"><el-input v-model="memberForm.remark" placeholder="请输入" /></el-form-item>
        <el-form-item label="上传照片"><el-upload action="#" :auto-upload="false" :show-file-list="false" :on-change="handlePhotoChange"><div class="photo-uploader"><img v-if="memberForm.ownerPhotoUrl" :src="memberForm.ownerPhotoUrl" /><i v-else class="el-icon-plus"></i></div></el-upload></el-form-item>
      </el-form>
      <span slot="footer"><el-button class="dialog-cancel" @click="memberDialogVisible = false">取消</el-button><el-button class="dialog-confirm" type="primary" @click="submitMember">提交</el-button></span>
    </el-dialog>

    <el-dialog title="添加车辆" :visible.sync="carDialogVisible" width="650px" custom-class="property-owner-dialog" :close-on-click-modal="false">
      <el-form :model="carForm" :rules="carRules" ref="carFormRef" label-width="96px" class="dialog-form">
        <el-form-item label="车牌号" prop="carNum"><el-input v-model="carForm.carNum" placeholder="必填，请填写车牌号" /></el-form-item>
        <el-form-item label="汽车品牌"><el-input v-model="carForm.carBrand" placeholder="选填，请填写汽车品牌" /></el-form-item>
        <el-form-item label="车类型" prop="carType"><el-select v-model="carForm.carType" placeholder="必填，请选择车辆类型"><el-option v-for="item in carTypes" :key="item.statusCd" :label="item.name" :value="item.statusCd" /></el-select></el-form-item>
        <el-form-item label="颜色"><el-input v-model="carForm.carColor" placeholder="选填，请填写颜色" /></el-form-item>
        <el-form-item label="车牌类型" prop="leaseType"><el-select v-model="carForm.leaseType" placeholder="必填，请选择车牌类型" @change="changeCarLeaseType"><el-option label="月租车" value="H" /><el-option label="出售车辆" value="S" /><el-option label="内部车" value="I" /><el-option label="免费车" value="NM" /></el-select></el-form-item>
        <el-form-item v-if="showCarDateRange" label="开始时间" prop="startTime"><el-date-picker v-model="carForm.startTime" type="date" value-format="yyyy-MM-dd" placeholder="必填，请填写开始时间" /></el-form-item>
        <el-form-item v-if="showCarDateRange" label="结束时间" prop="endTime"><el-date-picker v-model="carForm.endTime" type="date" value-format="yyyy-MM-dd" placeholder="必填，请填写结束时间" /></el-form-item>
        <el-form-item label="业主" prop="ownerName"><el-input :value="ownerInfo.name" disabled placeholder="必填，请选择业主" /></el-form-item>
        <el-form-item label="车位" prop="psId"><el-input v-model="carForm.psName" placeholder="必填，请选择车位" readonly @focus="openParkingSelector"><el-button slot="append" @click="openParkingSelector">选择</el-button></el-input></el-form-item>
        <el-form-item label="备注"><el-input v-model="carForm.remark" type="textarea" :rows="3" placeholder="选填，请填写备注" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button class="dialog-cancel" @click="carDialogVisible = false">取消</el-button><el-button class="dialog-confirm" type="primary" @click="submitCar">提交</el-button></span>
    </el-dialog>

    <el-dialog title="添加房产" :visible.sync="roomDialogVisible" width="560px" custom-class="property-owner-dialog" :close-on-click-modal="false">
      <el-form :model="roomForm" :rules="roomRules" ref="roomFormRef" label-width="88px" class="dialog-form">
        <el-form-item label="业主"><el-input :value="ownerInfo.name" readonly class="readonly-input" /></el-form-item>
        <el-form-item label="房屋" prop="roomIds"><el-input v-model="roomForm.roomName" placeholder="请选择" readonly @focus="openRoomSelector"><el-button slot="append" @click="openRoomSelector">选择</el-button></el-input></el-form-item>
        <el-form-item label="开始时间" prop="startTime"><el-date-picker v-model="roomForm.startTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择" /></el-form-item>
        <el-form-item label="结束时间" prop="endTime"><el-date-picker v-model="roomForm.endTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button class="dialog-cancel" @click="roomDialogVisible = false">取消</el-button><el-button class="dialog-confirm" type="primary" @click="submitRoomBind">确定</el-button></span>
    </el-dialog>

    <el-dialog title="选择房屋" :visible.sync="roomSelectorVisible" width="900px" custom-class="property-owner-dialog" append-to-body>
      <div class="selector-search"><el-input v-model="roomSearch.roomNum" placeholder="请输入房屋编号" /><el-input v-model="roomSearch.floorNum" placeholder="请输入楼区编号" /><el-button class="property-btn-search" @click="loadAvailableRooms">搜索</el-button></div>
      <el-table ref="availableRoomTable" :data="availableRooms" row-key="roomId" :header-cell-style="headerCellStyle" :cell-style="cellStyle" style="width: 100%" @selection-change="handleRoomSelectionChange">
        <el-table-column type="selection" width="48" />
        <el-table-column prop="communityName" label="所属小区" min-width="150" show-overflow-tooltip />
        <el-table-column prop="roomId" label="房屋ID" min-width="130" />
        <el-table-column prop="floorNum" label="楼栋编号" min-width="120" />
        <el-table-column prop="unitNum" label="单元编号" min-width="120" />
        <el-table-column prop="layer" label="楼层" min-width="100" />
        <el-table-column label="操作" min-width="100"><template slot-scope="scope"><a class="action-link" @click="toggleRoom(scope.row)">{{ isRoomSelected(scope.row) ? '已选择' : '选择' }}</a></template></el-table-column>
      </el-table>
      <span slot="footer"><el-button class="dialog-cancel" @click="roomSelectorVisible = false">取消</el-button><el-button class="dialog-confirm" type="primary" @click="confirmRoomSelection">确定</el-button></span>
    </el-dialog>

    <el-dialog title="选择停车位" :visible.sync="parkingSelectorVisible" width="780px" custom-class="property-owner-dialog" append-to-body>
      <div class="selector-search"><el-select v-model="parkingSearch.areaNum" placeholder="请选择停车场"><el-option v-for="item in parkingAreas" :key="item.num" :label="item.num" :value="item.num" /></el-select><el-input v-model="parkingSearch.num" placeholder="请输入停车位编号" /><el-button class="property-btn-search" @click="loadParkingSpaces">搜索</el-button><el-button class="property-btn-outline" @click="resetParkingSearch">重置</el-button></div>
      <el-table :data="parkingSpaces" :header-cell-style="headerCellStyle" :cell-style="plainCellStyle" style="width: 100%">
        <el-table-column prop="areaNum" label="停车场编码" min-width="120" />
        <el-table-column prop="num" label="停车位编码" min-width="120" />
        <el-table-column label="停车场类型" min-width="130"><template slot-scope="scope">{{ scope.row.typeCd === '1001' ? '地上停车位' : '地下停车位' }}</template></el-table-column>
        <el-table-column prop="parkingTypeName" label="车位类型" min-width="120" />
        <el-table-column prop="stateName" label="车位状态" min-width="120" />
        <el-table-column prop="area" label="面积" min-width="100" />
        <el-table-column label="操作" min-width="100"><template slot-scope="scope"><a class="action-link" @click="chooseParkingSpace(scope.row)">选择</a></template></el-table-column>
      </el-table>
      <span slot="footer"><el-button class="dialog-cancel" @click="parkingSelectorVisible = false">取消</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { getCommunityId, getDict, getEffectiveCommunityId } from '@/api/community/communityApi'
import { queryOwners } from '@/api/owner/ownerDetailApi'
import { queryRoomsByOwner } from '@/api/owner/ownerDetailRoomApi'
import { queryOwnerCars } from '@/api/owner/ownerDetailCarApi'
import { queryOwnerMembers } from '@/api/owner/ownerDetailMemberApi'
import { listComplaints } from '@/api/owner/ownerDetailComplaintApi'
import { listOwnerRepairs } from '@/api/owner/ownerDetailRepairApi'
import { saveOwnerMember } from '@/api/owner/addOwnerMemberApi'
import { sellRoom } from '@/api/owner/roomBindOwnerApi'
import { queryRooms } from '@/api/room/roomApi'
import { uploadFile } from '@/api/staff/addStaffApi'
import { saveOwnerCar, queryParkingSpaces, listParkingAreas } from '@/api/car/hireParkingSpaceApi'

export default {
  name: 'PropertyOwnerDetail',
  data() {
    return {
      ownerInfo: {},
      activeTab: 'rooms',
      tabs: [
        { name: 'rooms', label: '房产' },
        { name: 'cars', label: '车辆' },
        { name: 'members', label: '成员' },
        { name: 'complaints', label: '投诉' },
        { name: 'repairs', label: '报修' }
      ],
      keyword: '',
      loading: false,
      roomRows: [],
      carRows: [],
      memberRows: [],
      complaintRows: [],
      repairRows: [],
      pagination: { current: 1, size: 10, total: 0 },
      memberDialogVisible: false,
      carDialogVisible: false,
      roomDialogVisible: false,
      roomSelectorVisible: false,
      parkingSelectorVisible: false,
      memberForm: { personRole: '3', name: '', link: '', concactLink: '', address: '', accessKey: '', idCard: '', remark: '', ownerPhoto: '', ownerPhotoUrl: '', sex: '0', personType: 'P' },
      memberRules: { personRole: [{ required: true, message: '请选择', trigger: 'change' }], sex: [{ required: true, message: '请选择', trigger: 'change' }], name: [{ required: true, message: '请输入客户名称', trigger: 'blur' }], link: [{ required: true, message: '请输入联系手机', trigger: 'blur' }] },
      carForm: { carNum: '', carBrand: '', carType: '', carColor: '', leaseType: 'H', startTime: '', endTime: '', ownerName: '', ownerId: '', psId: '', psName: '', remark: '', attrs: [] },
      carRules: {
        carNum: [{ required: true, message: '车牌号不能为空', trigger: 'blur' }],
        carType: [{ required: true, message: '车类型不能为空', trigger: 'change' }],
        leaseType: [{ required: true, message: '车牌类型不能为空', trigger: 'change' }],
        startTime: [{ required: true, message: '开始时间不能为空', trigger: 'change' }],
        endTime: [{ required: true, message: '结束时间不能为空', trigger: 'change' }],
        ownerName: [{ required: true, message: '业主不能为空', trigger: 'change' }],
        psId: [{ required: true, message: '车位不能为空', trigger: 'change' }]
      },
      carTypes: [],
      parkingAreas: [],
      parkingSpaces: [],
      parkingSearch: { areaNum: '', num: '' },
      roomForm: { roomIds: [], roomName: '', startTime: '', endTime: '2099-01-01', state: '2001' },
      roomRules: { roomIds: [{ required: true, type: 'array', min: 1, message: '请选择房屋', trigger: 'change' }], startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }], endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }] },
      roomSearch: { roomNum: '', floorNum: '' },
      availableRooms: [],
      selectedRooms: []
    }
  },
  computed: {
    showCarDateRange() {
      return ['H', 'S'].includes(this.carForm.leaseType)
    }
  },
  created() {
    this.loadOwnerInfo()
  },
  methods: {
    async loadOwnerInfo() {
      const ownerId = this.$route.query.ownerId
      if (!ownerId) return
      const { data } = await queryOwners({ ownerId, page: 1, row: 1, ownerTypeCd: '1001' })
      this.ownerInfo = data && data.length ? data[0] : { ownerId }
      this.loadTabData()
    },
    changeTab(tab) { this.activeTab = tab; this.keyword = ''; this.pagination.current = 1; this.loadTabData() },
    queryCurrentTab() { this.pagination.current = 1; this.loadTabData() },
    refreshCurrentTab() { this.pagination.current = 1; this.loadTabData() },
    handleCurrentChange(page) { this.pagination.current = page; this.loadTabData() },
    handleSizeChange(size) { this.pagination.size = size; this.pagination.current = 1; this.loadTabData() },
    async loadTabData() {
      this.loading = true
      try {
        const page = this.pagination.current
        const row = this.pagination.size
        const ownerId = this.ownerInfo.ownerId || this.$route.query.ownerId
        let res = {}
        if (this.activeTab === 'rooms') {
          res = await queryRoomsByOwner({ ownerId, roomNum: this.keyword, page, row })
          this.roomRows = res.rooms || []
        } else if (this.activeTab === 'cars') {
          res = await queryOwnerCars({ ownerId, carNum: this.keyword, page, row })
          this.carRows = res.data || []
        } else if (this.activeTab === 'members') {
          res = await queryOwnerMembers({ ownerId, name: this.keyword, page, row })
          this.memberRows = res.data || []
        } else if (this.activeTab === 'complaints') {
          res = await listComplaints({ memberId: ownerId, tel: this.ownerInfo.link, page, row })
          this.complaintRows = res.data || []
        } else if (this.activeTab === 'repairs') {
          res = await listOwnerRepairs({ ownerId, page, row })
          this.repairRows = res.data || []
        }
        this.pagination.total = Number(res.total || 0)
      } finally {
        this.loading = false
      }
    },
    openAddMemberDialog() { this.memberForm = { personRole: '3', name: '', link: '', concactLink: '', address: '', accessKey: '', idCard: '', remark: '', ownerPhoto: '', ownerPhotoUrl: '', sex: '0', personType: 'P' }; this.memberDialogVisible = true },
    async openAddCarDialog() {
      this.carForm = { carNum: '', carBrand: '', carType: '', carColor: '', leaseType: 'H', startTime: this.today(), endTime: '2050-01-01', ownerName: this.ownerInfo.name || '', ownerId: this.ownerInfo.ownerId || '', psId: '', psName: '', remark: '', attrs: [] }
      this.carDialogVisible = true
      if (!this.carTypes.length) {
        try { this.carTypes = await getDict('owner_car', 'car_type') } catch (error) { this.carTypes = [] }
      }
    },
    openAddRoomDialog() { this.roomForm = { roomIds: [], roomName: '', startTime: this.today(), endTime: '2099-01-01', state: '2001' }; this.selectedRooms = []; this.roomDialogVisible = true },
    async submitMember() {
      this.$refs.memberFormRef.validate(async valid => {
        if (!valid) return
        const res = await saveOwnerMember({ ...this.memberForm, ownerId: this.ownerInfo.ownerId, communityId: getCommunityId() })
        if (res.code === 0) { this.$message.success('操作成功'); this.memberDialogVisible = false; this.loadTabData() } else { this.$message.error(res.msg || '提交失败') }
      })
    },
    async submitRoomBind() {
      this.$refs.roomFormRef.validate(async valid => {
        if (!valid) return
        try {
          await Promise.all(this.selectedRooms.map(room => sellRoom({
            roomId: room.roomId,
            roomName: this.roomName(room),
            startTime: this.roomForm.startTime,
            endTime: this.roomForm.endTime,
            state: this.roomForm.state,
            ownerId: this.ownerInfo.ownerId,
            ownerName: this.ownerInfo.name,
            communityId: room.communityId
          })))
          this.$message.success('操作成功')
          this.roomDialogVisible = false
          this.loadTabData()
        } catch (error) {
          this.$message.error(error.message || '提交失败')
        }
      })
    },
    changeCarLeaseType() {
      if (this.showCarDateRange) {
        this.carForm.startTime = this.carForm.startTime || this.today()
        this.carForm.endTime = this.carForm.endTime || '2050-01-01'
      } else {
        this.carForm.startTime = ''
        this.carForm.endTime = ''
      }
      this.$nextTick(() => this.$refs.carFormRef && this.$refs.carFormRef.clearValidate(['startTime', 'endTime']))
    },
    async submitCar() {
      this.$refs.carFormRef.validate(async valid => {
        if (!valid) return
        try {
          await saveOwnerCar({ ...this.carForm, ownerId: this.ownerInfo.ownerId, ownerName: this.ownerInfo.name, communityId: getCommunityId() })
          this.$message.success('操作成功')
          this.carDialogVisible = false
          this.loadTabData()
        } catch (error) {
          this.$message.error(error.message || '提交失败')
        }
      })
    },
    async openParkingSelector() {
      this.parkingSelectorVisible = true
      if (!this.parkingAreas.length) {
        const res = await listParkingAreas({ page: 1, row: 50, communityId: getEffectiveCommunityId() })
        this.parkingAreas = res.parkingAreas || []
      }
      this.loadParkingSpaces()
    },
    async loadParkingSpaces() {
      const res = await queryParkingSpaces({ page: 1, row: 10, communityId: getEffectiveCommunityId(), areaNum: this.parkingSearch.areaNum, num: this.parkingSearch.num, state: 'F' })
      this.parkingSpaces = res.parkingSpaces || []
    },
    resetParkingSearch() {
      this.parkingSearch = { areaNum: '', num: '' }
      this.loadParkingSpaces()
    },
    chooseParkingSpace(parkingSpace) {
      this.carForm.psId = parkingSpace.psId
      this.carForm.psName = `${parkingSpace.areaNum}-${parkingSpace.num}`
      this.parkingSelectorVisible = false
      this.$nextTick(() => this.$refs.carFormRef && this.$refs.carFormRef.validateField('psId'))
    },
    openRoomSelector() {
      this.roomSelectorVisible = true
      this.loadAvailableRooms()
    },
    async loadAvailableRooms() {
      const res = await queryRooms({ state: '2002', roomNum: this.roomSearch.roomNum, floorNum: this.roomSearch.floorNum, page: 1, row: 10 })
      this.availableRooms = res.rooms || res.data || []
      this.$nextTick(() => {
        if (!this.$refs.availableRoomTable) return
        this.availableRooms.forEach(room => {
          this.$refs.availableRoomTable.toggleRowSelection(room, this.isRoomSelected(room))
        })
      })
    },
    isRoomSelected(room) { return this.roomForm.roomIds.includes(room.roomId) },
    toggleRoom(room) {
      if (this.isRoomSelected(room)) {
        this.selectedRooms = this.selectedRooms.filter(item => item.roomId !== room.roomId)
      } else {
        this.selectedRooms = [...this.selectedRooms, room]
      }
      if (this.$refs.availableRoomTable) {
        this.$refs.availableRoomTable.toggleRowSelection(room, this.isRoomSelected(room))
      }
      this.syncSelectedRooms()
    },
    handleRoomSelectionChange(selection) {
      const selectedMap = new Map(this.selectedRooms.map(item => [item.roomId, item]))
      selection.forEach(item => selectedMap.set(item.roomId, item))
      const visibleIds = this.availableRooms.map(item => item.roomId)
      this.selectedRooms = Array.from(selectedMap.values()).filter(item => !visibleIds.includes(item.roomId) || selection.some(row => row.roomId === item.roomId))
      this.syncSelectedRooms()
    },
    syncSelectedRooms() {
      this.roomForm.roomIds = this.selectedRooms.map(item => item.roomId)
      this.roomForm.roomName = this.selectedRooms.map(item => this.roomName(item)).join('、')
      this.$nextTick(() => this.$refs.roomFormRef && this.$refs.roomFormRef.validateField('roomIds'))
    },
    confirmRoomSelection() {
      this.roomForm.roomIds = this.selectedRooms.map(item => item.roomId)
      this.roomForm.roomName = this.selectedRooms.map(item => this.roomName(item)).join('、')
      this.roomSelectorVisible = false
    },
    deleteMember(row) { this.$message.warning(`请在成员详情中删除：${row.name || ''}`) },
    async handlePhotoChange(file) {
      this.memberForm.ownerPhotoUrl = URL.createObjectURL(file.raw)
      try { const res = await uploadFile(file.raw); this.memberForm.ownerPhoto = res.fileId || res.data || '' } catch (e) { this.memberForm.ownerPhoto = '' }
    },
    roomName(row) { return row.roomName || [row.floorNum, row.unitNum, row.roomNum].filter(Boolean).join('-') || '-' },
    genderText(sex) { if (String(sex) === '0') return '男'; if (String(sex) === '1') return '女'; return sex || '-' },
    statusClass(state) { return String(state) === '2001' ? 'status-occupied' : 'status-unsold' },
    today() { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}` },
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px' } },
    plainCellStyle({ row }) { const idx = this.parkingSpaces.indexOf(row); return { background: idx % 2 === 1 ? '#F8FBFF' : '#FFFFFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px' } },
    cellStyle({ row }) { const rows = this[`${this.activeTab.slice(0, -1)}Rows`] || []; const idx = rows.indexOf(row); return { background: idx % 2 === 1 ? '#F8FBFF' : '#FFFFFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px' } }
  }
}
</script>

<style lang="scss" scoped>
.property-owner-detail-page { padding: 20px; background: #EBF2FA; min-height: calc(100vh - 100px); }
.property-white-card { background: #fff; border-radius: 12px; padding: 22px 24px; min-height: calc(100vh - 120px); }
.detail-header { display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #DCE6F5; padding-bottom: 18px; }
.detail-title { color: #1D2129; font: 600 16px/22px 'PingFang SC', sans-serif; }
.detail-back-btn { height: 38px; border-radius: 10px; border-color: #0E76FF; color: #0E76FF; padding: 0 18px; }
.owner-profile { display: flex; gap: 24px; padding: 22px 0; }
.owner-avatar-card { width: 86px; height: 109px; border-radius: 8px; background: #C4DDFF; overflow: hidden; }
.owner-avatar-large { width: 86px; height: 109px; }
.owner-fields { flex: 1; display: grid; grid-template-columns: repeat(4, minmax(160px, 1fr)); gap: 14px 24px; color: #1D2129; font: 400 14px/22px 'PingFang SC', sans-serif; align-items: start; }
.owner-field { display: flex; align-items: flex-start; min-width: 0; word-break: break-all; }
.owner-field span { color: #364153; }
.owner-field-remark { grid-column: 1 / 3; }
.detail-tabs { display: flex; gap: 28px; margin: 6px 0 20px; padding-bottom: 0; border-bottom: 1px solid #DCE6F5; }
.detail-tab { position: relative; min-width: 78px; height: 60px; border: 0; border-radius: 0; background: transparent; color: #364153; cursor: pointer; font: 600 14px/34px 'PingFang SC', sans-serif; }
.detail-tab.active { background: transparent; color: #0E76FF; }
.detail-tab.active::after { content: ''; position: absolute; left: 50%; bottom: -1px; width: 44px; height: 3px; border-radius: 999px; background: #0E76FF; transform: translateX(-50%); }
.detail-toolbar, .toolbar-left, .toolbar-search, .property-pagination, .selector-search { display: flex; align-items: center; gap: 12px; }
.detail-toolbar { justify-content: space-between; margin-bottom: 24px; }
.toolbar-search { margin-left: auto; }
.property-btn-add { height: 38px; border-radius: 10px; border: 0; background: #0E76FF; color: #fff; padding: 0 18px; }
.property-btn-outline, .property-btn-search { height: 38px; border-radius: 10px; border-color: #0E76FF; color: #0E76FF; background: #fff; padding: 0 16px; }
.property-btn-refresh { width: 38px; height: 38px; border-radius: 10px; border: 1px solid #DCE6F5; color: #0E76FF; background: #fff; padding: 0; }
.property-btn-refresh:hover { border-color: #0E76FF; color: #0E76FF; }
.property-search-input { width: 256px; }
::v-deep .property-search-input .el-input__inner { height: 38px; border-radius: 10px; border-color: #DCE6F5; }
.detail-table-section { border-radius: 10px; overflow: hidden; }
.status-tag { display: inline-flex; align-items: center; justify-content: center; min-width: 66px; height: 28px; border-radius: 8px; padding: 0 12px; }
.status-occupied { color: #21B956; background: rgba(33, 185, 86, .1); outline: 1px solid #21B956; outline-offset: -1px; }
.status-unsold { color: #8C9BB4; background: rgba(140, 155, 180, .1); outline: 1px solid #8C9BB4; outline-offset: -1px; }
.action-link { color: #0E76FF; cursor: pointer; }
.action-link.danger { color: #FB2C36; }
.property-pagination { justify-content: flex-end; margin-top: 20px; }
.pagination-total { color: #1D2129; font: 500 14px/22px 'PingFang SC', sans-serif; }
.pagination-size-select { width: 90px; }
::v-deep .pagination-size-select .el-input__inner { height: 32px; border: 0; border-radius: 8px; background: #F2F3F5; }
.dialog-form .el-select, .dialog-form .el-date-editor { width: 100%; }
.dialog-form ::v-deep .el-form-item__label { color: #364153; font-weight: 400; white-space: nowrap; }
.dialog-form ::v-deep .el-input__inner { height: 38px; border-radius: 10px; border-color: #DCE6F5; }
.dialog-form ::v-deep .readonly-input .el-input__inner,
.dialog-form ::v-deep .el-input.is-disabled .el-input__inner { background: #F2F3F5; color: #8C9BB4; cursor: not-allowed; }
.property-owner-dialog ::v-deep .el-dialog__header { padding: 22px 24px 16px; border-bottom: 1px solid #DCE6F5; }
.property-owner-dialog ::v-deep .el-dialog__title { color: #1D2129; font: 600 16px/22px 'PingFang SC', sans-serif; }
.property-owner-dialog ::v-deep .el-dialog__body { padding: 22px 24px; }
.property-owner-dialog ::v-deep .el-dialog__footer { padding: 0 24px 22px; }
.photo-uploader { width: 86px; height: 86px; border-radius: 8px; background: #F2F3F5; display: flex; align-items: center; justify-content: center; overflow: hidden; }
.photo-uploader img { width: 100%; height: 100%; object-fit: cover; }
.dialog-cancel, .dialog-confirm { min-width: 88px; height: 38px; border-radius: 10px; }
.selector-search { margin-bottom: 16px; }
.selector-search .el-input { width: 200px; }
@media (max-width: 900px) { .owner-profile { flex-direction: column; } .owner-fields { grid-template-columns: 1fr; } .detail-toolbar { flex-direction: column; align-items: stretch; } .toolbar-search { margin-left: 0; } }
</style>
